/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';

import { validDate } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../../SharedModules/DateUtilities/DateUtilities';
import {
  MinDate,
  MaxDate,
} from '../../../../../SharedModules/CommonConstants/commonConstants';
import { maintainLabelerListData } from '../../store/ManufacturerAction';

export default (props) => {
  const { isEnablebyRole } = props;
  const dispatch = useDispatch();
  const addEditManufacturerLabelersData = (value, action) => {
    dispatch(maintainLabelerListData(value, action));
  };
  const labelerRowData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.labelersList;
  });

  const handleChangeDate = (d) => {
    const newObj = [...labelerRowData];
    if (d.target.value) {
      let { value } = d.target;
      if (d.target.value && d.target.value.length > 5) {
        const data = d?.target.value?.split('/');
        if (data[2]?.split('_')?.length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          value = d?.target?.value !== '' ? d.target.value : null;
        }
      }
      const { colId } = props.column;
      if (colId === 'startDate') {
        if (value === '' || value === null) {
          props.node.setDataValue(colId, value);
          newObj[props.rowIndex].startDate = value;
          newObj[props.rowIndex].startDateErr = true;
          addEditManufacturerLabelersData(newObj, 'verify');
        } else if (
          value !== null &&
          value !== '' &&
          validDate(new Date(value)) === false
        ) {
          props.node.setDataValue(colId, value);
          newObj[props.rowIndex].startDate = value;
          newObj[props.rowIndex].startDateErr = true;
          addEditManufacturerLabelersData(newObj, 'verify');
        } else if (
          value !== null &&
          value !== '' &&
          compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))
        ) {
          props.node.setDataValue(colId, value);
          newObj[props.rowIndex].startDate = value;
          newObj[props.rowIndex].startDateErr = true;
          addEditManufacturerLabelersData(newObj, 'verify');
        } else {
          if (
            props.data.endDate !== null &&
            props.data.endDate !== '' &&
            props.data.endDate !== 'Invalid date' &&
            compareTwoDatesGreaterThanOrEqual(
              new Date(props.data.endDate),
              moment(new Date(value))
            )
          ) {
            newObj[props.rowIndex].endDateErr = true;
          } else {
            newObj[props.rowIndex].endDateErr = false;
          }
          props.node.setDataValue(colId, value);
          newObj[props.rowIndex].startDate = value;
          newObj[props.rowIndex].startDateErr = false;
          addEditManufacturerLabelersData(newObj, 'verify');
        }
      } else if (
        value !== null &&
        value !== '' &&
        validDate(new Date(value)) === false
      ) {
        props.node.setDataValue(colId, value);
        newObj[props.rowIndex].D = value;
        newObj[props.rowIndex].endDateErr = true;
        addEditManufacturerLabelersData(newObj, 'verify');
      } else if (
        value !== null &&
        value !== '' &&
        compareTwoDatesGreaterThanOrEqual(
          new Date(value),
          moment(newObj[props.rowIndex].startDate)
        )
      ) {
        props.node.setDataValue(colId, value);
        newObj[props.rowIndex].endDate = value;
        newObj[props.rowIndex].endDateErr = true;
        addEditManufacturerLabelersData(newObj, 'verify');
      } else {
        props.node.setDataValue(colId, value);
        newObj[props.rowIndex].endDate = value;
        newObj[props.rowIndex].endDateErr = false;
        addEditManufacturerLabelersData(newObj, 'verify');
      }
    }
  };
  // handing on change date event
  const handleOnChangeDateFields = (d, colId) => {
    const newObj = [...labelerRowData];
    if (d !== 'Invalid Date') {
      props.node.setDataValue(colId, d);
      if (colId === 'startDate') {
        newObj[props.rowIndex].startDate = d;
        newObj[props.rowIndex].startDateErr = false;
      }
      if (colId === 'endDate') {
        newObj[props.rowIndex].endDate = d;
        newObj[props.rowIndex].endDateErr = false;
      }
      addEditManufacturerLabelersData(newObj, 'verify');
    }
  };
  return (
    <div data-testid='mfg-labeler-date-picker'>
      {props.column.colId === 'startDate' ? (
        props.data &&
        props.data.mfgTypeCd === 'G' &&
        props.data.mfgId !== null ? (
          <div className='tdCell icon-btn-group'>
            <span className='td-date-range'>
              {moment(props.value).format('MM/DD/YYYY')}
              {'   '} <SVGComponent iconName='Icon_date-range' />
            </span>
          </div>
        ) : (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              required
              id='begin_date_net_association_bp_tab'
              data-testid='start-date'
              className={
                labelerRowData &&
                labelerRowData[props.rowIndex] &&
                labelerRowData[props.rowIndex].startDateErr !== undefined &&
                labelerRowData[props.rowIndex].startDateErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              label={false}
              format='MM/dd/yyyy'
              InputLabelProps={{ shrink: true }}
              InputProps={{
                readOnly: false,
                autoFill: false,
              }}
              placeholder='mm/dd/yyyy'
              mask='__/__/____'
              minDate={MinDate}
              maxDate={MaxDate}
              value={props.value}
              onChange={(d) => {
                handleOnChangeDateFields(d, 'startDate');
              }}
              onBlur={(e) => {
                handleChangeDate(e, 'onBlur');
              }}
              onKeyDown={async (e) => {
                if (e.keyCode == 67) {
                  // copy date
                  await window.navigator?.clipboard.writeText(e?.target?.value);
                }
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              helperText={null}
              error={null}
            />
          </MuiPickersUtilsProvider>
        )
      ) : props.data &&
        props.data.mfgTypeCd !== undefined &&
        props.data.mfgTypeCd === 'G' ? (
        <div className='tdCell icon-btn-group'>
          <span className='td-date-range'>
            {props.value !== 'Invalid date' &&
            props.value !== null &&
            props.value !== ''
              ? moment(props.value).format('MM/DD/YYYY')
              : ''}
            <SVGComponent iconName='Icon_date-range' />
          </span>
        </div>
      ) : (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            required
            id='begin_date_net_association_bp_tab'
            data-testid='end-date'
            className={
              labelerRowData &&
              labelerRowData[props.rowIndex] &&
              labelerRowData[props.rowIndex].endDateErr !== undefined &&
              labelerRowData[props.rowIndex].endDateErr
                ? 'td-active-cell tBill-validate'
                : ''
            }
            label={false}
            format='MM/dd/yyyy'
            mask='__/__/____'
            InputLabelProps={{ shrink: true }}
            InputProps={{
              readOnly: false,
              autoFill: false,
            }}
            placeholder='mm/dd/yyyy'
            minDate={new Date(props.data.startDate)}
            maxDate={MaxDate}
            value={props.value}
            onChange={(d) => {
              handleOnChangeDateFields(d, 'endDate');
            }}
            onBlur={(e) => {
              handleChangeDate(e, 'onBlur');
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            onKeyDown={async (e) => {
              if (e.keyCode == 67) {
                // copy date
                await window.navigator?.clipboard.writeText(e?.target?.value);
              }
            }}
            helperText={null}
            error={null}
          />
        </MuiPickersUtilsProvider>
      )}
    </div>
  );
};
